(() => {
  'use strict';
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const config = window.Cieluxi;
  const money = value => new Intl.NumberFormat(config.locale, {style: 'currency', currency: config.currency}).format(value / 100);
  function syncBundles(root) {
    const group = root.querySelector('[data-bundle-group]');
    const source = root.querySelector('[data-variants]');
    const select = root.querySelector('[data-variant-id]');
    if (!group || !source || !select) return;
    const variants = JSON.parse(source.textContent);
    const current = variants.find(variant => String(variant.id) === select.value);
    if (!current) return;
    const index = Number(group.dataset.optionIndex);
    const selectedUnits = Math.max(1, parseInt(current.options[index], 10) || 1);
    const colorGroup = root.querySelector('[data-single-color]');
    if (colorGroup) colorGroup.hidden = true;

    all('[data-bundle-offer]', root).forEach(offer => {
      const card = offer.querySelector('[data-bundle-card]');
      offer.dataset.selected = String(Number(card.dataset.bundleUnits) === selectedUnits);
    });
    all('[data-style-picker]', root).forEach(picker => {
      const active = Number(picker.dataset.pickerUnits) === selectedUnits;
      picker.hidden = !active;
      all('[data-mix-toy]', picker).forEach(select => {
        select.disabled = !active;
        if (select.dataset.mixToy === '1') select.value = current.options[1];
        else select.value = root.dataset['style' + select.dataset.mixToy] || current.options[1];
        const photo = variants.find(variant => variant.options[1] === select.value && variant.featured_image)?.featured_image;
        const image = select.closest('.cx-style-row').querySelector('.cx-style-image');
        if (photo && image) {
          image.removeAttribute('srcset');
          image.src = photo.src;
        }
      });
    });
    const sameOptions = variant => variant.options.every((value, position) => position === index || value === current.options[position]);
    const single = variants.find(variant => sameOptions(variant) && parseInt(variant.options[index], 10) === 1);
    all('[data-bundle-card]', group).forEach(card => {
      const variant = variants.find(item => sameOptions(item) && item.options[index] === card.dataset.optionValue);
      if (!variant) return;
      const units = Math.max(1, Number(card.dataset.bundleUnits));
      const price = window.SantaOffer?.price(variant) ?? variant.price;
      card.querySelector('[data-bundle-price]').textContent = money(price);
      card.querySelector('[data-bundle-each]').textContent = money(price / units) + ' ' + root.dataset.bundleEach;
      const compare = variant.compare_at_price;
      const amount = Math.max(0, (compare || 0) - price);
      const compareElement = card.querySelector('[data-bundle-compare]');
      const savings = card.querySelector('[data-bundle-saving]');
      compareElement.hidden = !amount;
      savings.hidden = !amount;
      compareElement.textContent = amount ? money(compare) : '';
      savings.textContent = amount ? root.dataset.bundleSave.replace('[amount]', money(amount)) : '';
    });
  }
  function activateFaq(root, category, focus = false) {
    const tabs = all('[data-faq-tab]', root);
    if (!tabs.some(tab => tab.dataset.faqTab === category)) return;
    tabs.forEach(tab => {
      const active = tab.dataset.faqTab === category;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });
    all('[data-faq-panel]', root).forEach(panel => { panel.hidden = panel.dataset.faqPanel !== category; });
  }
  function init(scope = document) {
    all('[data-product-root]', scope).forEach(syncBundles);
    all('[data-good-to-know]', scope).forEach(root => {
      if (root.dataset.enhanced) return;
      root.dataset.enhanced = 'true';
      activateFaq(root, root.querySelector('[data-faq-tab]')?.dataset.faqTab);
    });
  }
  document.addEventListener('click', event => {
    const pause = event.target.closest('[data-ticker-toggle]');
    if (pause) {
      const root = pause.closest('[data-ticker]');
      const paused = root.dataset.paused !== 'true';
      root.dataset.paused = String(paused);
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? pause.dataset.labelResume : pause.dataset.labelPause);
      pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      return;
    }
    const tab = event.target.closest('[data-faq-tab]');
    if (tab) activateFaq(tab.closest('[data-good-to-know]'), tab.dataset.faqTab);
    const jump = event.target.closest('[data-faq-target]');
    if (jump) {
      const root = document.querySelector('[data-good-to-know]');
      if (root) activateFaq(root, jump.dataset.faqTarget);
    }
    const option = event.target.closest('[data-option-value],[data-gallery-src]');
    if (option) queueMicrotask(() => syncBundles(option.closest('[data-product-root]')));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-mix-toy="1"]')) {
      const root = event.target.closest('[data-product-root]');
      const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      const units = Number(event.target.closest('[data-style-picker]').dataset.pickerUnits);
      const pack = units === 1 ? '1 Unit' : units + ' Units';
      const variant = variants.find(item => item.options[0] === pack && item.options[1] === event.target.value);
      if (variant) {
        const nativeSelect = root.querySelector('[data-variant-id]');
        nativeSelect.value = String(variant.id);
        nativeSelect.dispatchEvent(new Event('change', {bubbles: true}));
      }
    }
    if (event.target.matches('[data-mix-toy]') && Number(event.target.dataset.mixToy) > 1) {
      const root = event.target.closest('[data-product-root]');
      root.dataset['style' + event.target.dataset.mixToy] = event.target.value;
      syncBundles(root);
    }
    if (event.target.matches('[data-variant-id]')) syncBundles(event.target.closest('[data-product-root]'));
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-faq-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const root = tab.closest('[data-good-to-know]');
    const tabs = all('[data-faq-tab]', root);
    let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    activateFaq(root, tabs[index].dataset.faqTab, true);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-faq-panel]');
    if (panel) activateFaq(panel.closest('[data-good-to-know]'), panel.dataset.faqPanel);
  });
  document.addEventListener('spt:offer-change', () => all('[data-product-root]').forEach(syncBundles));
  init();
})();

